export const all_articles = [
    {
        image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/3GML2T366RBBBIDG5NKZEYS3DU.jpg",
        article_title: "Lions, Tigers, and Bears, oh my! A guide to the 2025 Ivy League women’s basketball season",
        article_authors: "Jillian Prunty, Alison Chiu",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/lions-tigers-and-bears-oh-my-a-guide-to-the-2025-ivy-league-womens-basketball-season/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/LIK3NVUU7ZCQBEOWIKFHLEPGA4.jpg?auth=2989bd3a614f903a329d171b8a0cc502071faa744d52e189f612cc20b72b5068",
        article_title: "Can men’s basketball make it to March Madness? What to expect from 2024-25 Ivy League play",
        article_authors: "Andrew Vincenti",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/can-mens-basketball-make-it-to-march-madness-what-to-expect-from-2024-25-ivy-league-play/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/427YL2HVLZHI3KNY2IN3HEQVBQ.jpg?auth=01bcc133f3a5a6dc80c841361b022137811118a7e59a3a04489f373d66dfdd5b",
        article_title: "Newcomers by the numbers: How first-years on men’s basketball have aided a historic start",
        article_authors: "Benjamin Rubin",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/19/newcomers-by-the-numbers-how-first-years-on-mens-basketball-have-aided-a-historic-start/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/4BA62GLBKVH4RE2Z3AJKRUFS6A.jpg?auth=b14ca238fe817b97b77a7b716805efd133b4ed2131a61005a3da42823c02aace",
        article_title: "Lion cubs: Five new faces join women’s basketball",
        article_authors: "Arielle Rieder, Kaya Quebada",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/lion-cubs-five-new-faces-join-womens-basketball/"
    },
    {
        youtube_link: "https://www.youtube.com/watch?v=efdQ9tg9tWk",
        article_title: "Women’s basketball looks to three-peat in Ivy League title",
        article_authors: "Arielle Rieder, Nicky Fink, Heather Chen, Elliot Heath, Esmerelda Paredes",
        article_link: "https://www.youtube.com/watch?v=efdQ9tg9tWk"
    },
    {
        youtube_link: "https://www.youtube.com/shorts/0rtIzZSDlgY",
        article_title: "Star power and a historic start: Three things to know as men’s basketball eyes Ivy Madness",
        article_authors: "Arielle Rieder, Elliot Heath, Esmerelda Paredes, Salem Maru",
        article_link: "https://www.youtube.com/shorts/0rtIzZSDlgY"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/V4AYHFIUNBCLBNBXWZJVOS2FRQ.tif?auth=5beb3779ab5ca0cd768313a6c1491021a8b1915d26013d8fdaa252ad2db0236c",
        article_title: "Blau Tor, BC ’27, and María Arrebola, CC ’28, chase the game from Spain to Morningside Heights",
        article_authors: "Ashley Flores",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/blau-tor-bc-27-and-maria-arrebola-cc-28-chase-the-game-from-spain-to-morningside-heights/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/CZDLNE2SGJE47IYQLSDZ57ZNCM.jpg?auth=56a402c446359730ac0e9b00c00f332436bae2ec5d505dafbe7b65269cd77baf",
        article_title: "Men’s basketball falls to Yale, 92-88",
        article_authors: "Jillian Prunty",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/18/mens-basketball-falls-to-yale-92-88/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/HJVE4GVQLJEDHP4M2A5CBWUJDY.jpg?auth=6bb16816d2d6b33540821d78d278311ec0f891f52fd93410bf28649ee9cb787b",
        article_title: "Women’s basketball makes community connections beyond the court with Harlem Link Charter School",
        article_authors: "Ashley Flores",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/womens-basketball-makes-community-connections-beyond-the-court-with-harlem-link-charter-school/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/3IT2T4C3O5A5LOML5OMS5WOV7E.jpg?auth=f2b88c77b69ecb88bae21813e6f21bec2fd6ea8a85bb18dda9f22ea86808fce4",
        article_title: "Women’s basketball takes down Yale in New Haven",
        article_authors: "Arielle Rieder, Nicholas Fink",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/19/womens-basketball-takes-down-yale-in-new-haven/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/2KNXQ3K6RBHQ5D2IZ3JSW2YQH4.JPG?auth=0637b7acbdcbd8576cd6d5b966dcf0378e5ced478c2c64bd49ee5dbb1e53927e",
        article_title: "Fink: NIL collectives and athlete compensation could threaten the future of Ivy League men’s hoops",
        article_authors: "Nicholas Fink",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/fink-nil-collectives-and-athlete-compensation-could-threaten-the-future-of-ivy-league-mens-hoops/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/RJPL4XYXB5HTBE6ZRR4RZRHCKA.jpg?auth=25eca73f4370fbc3ffd7cfd938da8e14fc2a9428e58528c5ed8c27e3e271bdaa",
        article_title: "Women’s basketball defeats Princeton, 58-50",
        article_authors: "Arielle Rieder, Jllian Prunty",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/20/womens-basketball-defeats-princeton-58-50/"
    },
    {
        image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/MYCJXHX37BE73GJQRGYNBP5JJY.jpg",
        article_title: "Spectator breaks down eight years of men’s basketball under head coach Jim Engles",
        article_authors: "Benjamin Rubin",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/21/spectator-breaks-down-eight-years-of-mens-basketball-under-head-coach-jim-engles/"
    },
    {
        image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/PNQ5U2VT7VFNVNCNJQSUC4QBPY.jpg",
        article_title: "Geronimo Rubio De La Rosa’s ascent to Lions stardom through the numbers",
        article_authors: "Lucas Metzger, Emilia Lebeau",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/21/geronimo-rubio-de-la-rosas-ascent-to-lions-stardom-through-the-numbers/"
    }, 
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/WVYM3X44CFGVFJIKJAYXDJDVO4.jpg?auth=2ae653d2e7e3180ff16c30d13383a2e17dd70c9bd5e2645f6ad794e0d7e8e1df",
        article_title: "How associate head coach Tyler Cordell centers trust and family on the court",
        article_authors: "Olivia Madkins",
        article_link: "https://www.columbiaspectator.com/sports/2025/01/21/how-associate-head-coach-tyler-cordell-centers-trust-and-family-on-the-court/"
    }
];